import '../css/style.css'

export default function Content() {
    return(
        <div className='content'>
            <div className='header'>
                <p>
                    <h3>Do kompresorów śrubowych zapewniamy części zamienne i podzespoły takie jak:</h3>
                    <ul>
                      <li>kompletne moduły śrubowe</li>
                      <li>łożyska</li>
                      <li>zestawy naprawcze</li>
                      <li>chłodnice powietrza</li>
                      <li>chłodnice oleju</li>
                      <li>elementy układów automatyki oraz regulacji wydajności</li>
                    </ul>
                </p>
                <p>Dział sprężarek śrubowych rozszerzyliśmy o doradztwo techniczne oraz o ofertę na nowe kompresory śrubowe dla wszystkich gałęzi przemysłu.</p>
                <p>Program naszych dostaw w szczególności skupia się na maszynach o mocach od 5 do 250kW.</p>
            </div>
            <div className='photos'>
                <a href='https://dwb.com.pl/wp-content/uploads/2023/01/screwrotor-sm__large.jpg' target="_blank" rel="noreferrer"><img src="https://dwb.com.pl/wp-content/uploads/2023/01/screwrotor-sm__large.jpg" alt="photo1"/></a>
            </div>
        </div>
    )
}